module.exports = __webpack_public_path__ + "static/media/LEMONMILK-Regular.be29f3c5.otf";